import { http } from 'services/http';
import { CARGO_GET_ONE, CARGO_ITEMS_MANY } from 'api/query-keys.ts';
import type { CargoItemRes, CreateManyCargoItemsReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useCreateCargoItems = (cargoId: number) => {
  return useMutationBase<CargoItemRes[], unknown, CreateManyCargoItemsReq>({
    mutationFn: async (variables) => {
      const res = await http.post<CargoItemRes[]>(`/v1/cargo/${cargoId}/cargo-items/`, variables);

      return res.data;
    },

    invalidateCallback: () => [
      [CARGO_GET_ONE, cargoId],
      [CARGO_ITEMS_MANY, cargoId],
    ],
  });
};
